<template>
  <nav class="navbar navbar-toggleable-md navbar-inverse bg-darkgrey sticky-top box-shadow p-0">
    <button class="navbar-toggler navbar-toggler-right" type="button" data-toggle="collapse" data-target="#KeepNeyeNavbar">
      <span class="navbar-toggler-icon"></span>
    </button>
    <a class="navbar-brand" @click.prevent>
      <img src="../assets/KeepNeye.png" width="30" height="30" alt="">
    </a>
    <div class="collapse navbar-collapse" id="KeepNeyeNavbar">
      <ul class="navbar-nav mr-auto">
        <!-- <li class="nav-link">
          <span @click="$i18n.set('en')">EN</span>
        </li>
        <li class="nav-link">
          <span @click="$i18n.set('fr')">FR</span>
        </li> -->
        <li class="nav-item" :class="{'nav-select' : $route.name === 'Dashboard'}">
          <a class="nav-link" href="#/dashboard">{{$t('NavBar.dashboard')}}</a>
        </li>
        <li class="nav-item" :class="{'nav-select' : $route.name === 'OrderPending' || $route.name === 'OrderCurrent'}">
          <a class="nav-link" href="#/OrderCurrent">{{$t('NavBar.orders')}}</a>
        </li>
        <li class="nav-item" :class="{'nav-select' : $route.name === 'TransferPending' || $route.name === 'TransferCurrent'}">
          <a class="nav-link" href="#/TransferCurrent">{{$t('NavBar.transfer')}}</a>
        </li>
        <li class="nav-item" :class="{'nav-select' : $route.name === 'Search'}">
          <a class="nav-link" href="#/Search">{{$t('NavBar.search')}}</a>
        </li>
        <li class="nav-item" :class="{'nav-select' : $route.name === 'AddressBook'}">
          <a class="nav-link" href="#/AddressBook">{{$t('NavBar.address_book')}}</a>
        </li>
        <li class="nav-item" :class="{'nav-select' : $route.name === 'Users'}">
          <a class="nav-link" href="#/Users">{{$t('NavBar.users')}}</a>
        </li>
        <li v-if="isAdmin" class="nav-item" :class="{'nav-select' : $route.name === 'Logs'}">
          <a class="nav-link" href="#/Logs">{{$t('NavBar.logs')}}</a>
        </li>
        <li v-if="isAdmin" class="nav-item" :class="{'nav-select' : $route.name === 'Reports'}">
          <a class="nav-link" href="#/Reports">{{$t('NavBar.reports')}}</a>
        </li>
        <li class="nav-item" :class="{'nav-select' : $route.name === 'Settings'}">
          <a class="nav-link" href="#/Settings">{{$t('NavBar.settings')}}</a>
        </li>
      </ul>
      <span>
        <a id="logout" class="nav-link navbar-text" href="#" @click.prevent="signOut()">{{$t('NavBar.logout')}}</a>
      </span>
    </div>
  </nav>
</template>

<script>
import Firebase from 'firebase'
import router from '../router'

export default {
  data () {
    return {

    }
  },
  props: {
    selected: {
      type: String,
      requiered: false,
      default: 'Dashboard'
    }
  },
  methods: {
    signOut () {
      Firebase.auth().signOut().then(() => {
        this.$store.commit('clearUser')
        this.$store.commit('clearContacts')
        this.$store.commit('CLEAR_SEARCH')
        router.push({path: '/login'})
      }).catch(function () {
      })
    }
  },
  computed: {
    companyUID () {
      return this.$store.state.authorization.company
    },
    isAdmin () {
      return this.$store.state.authorization.role === 'Admin'
    },
    uid () {
      return this.$store.state.user.uid
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  li, a.navbar-brand{
    margin-left: 1rem;
  }
  li.dropdown.nav-item{
    cursor: pointer;
  }
  .nav-select{
    border-bottom: 3px solid #f7941e;
  }
  @media (max-width: 991px) {
    nav{
      padding-bottom: .5rem !important;
    }
  }
  #logout{
    background-color: #ff5151;
    color: white;
    height: 100%
  }
</style>



// WEBPACK FOOTER //
// NavBar.vue?5e94d545